import { render, staticRenderFns } from "./PassiveIncomeSimulator.vue?vue&type=template&id=3f00e04d"
import script from "./PassiveIncomeSimulator.vue?vue&type=script&lang=js"
export * from "./PassiveIncomeSimulator.vue?vue&type=script&lang=js"
import style0 from "./PassiveIncomeSimulator.vue?vue&type=style&index=0&id=3f00e04d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports